import { useEffect, useRef, useState } from 'react';

const assurances = [
  { icon: 'ri-heart-3-line', text: '加入 LINE@ 不等於報名，沒有任何強迫' },
  { icon: 'ri-chat-smile-3-line', text: '以了解你的狀態與疑問為主，不催促成交' },
  { icon: 'ri-time-line', text: '回覆時間：週一至週五 10:00–20:00' },
  { icon: 'ri-shield-check-line', text: '如果聊完覺得不適合，可以停在那裡' },
];

export default function ContactLineSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-28 bg-[#faf8f5]">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-14 items-center transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Left: LINE Info */}
          <div>
            <div className="flex items-center gap-3 mb-7">
              <div className="w-6 h-px bg-[#b08060]"></div>
              <span className="text-[0.8125rem] tracking-[0.2em] text-[#9a8470] font-medium uppercase">LINE@</span>
            </div>
            <h2
              className="font-serif-tc text-[#2c2420] leading-[1.4] mb-7"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              最直接的方式，
              <br />是加入 LINE@ 聊聊
            </h2>
            <p className="text-[1.1875rem] leading-[1.75] text-[#5a4e42] mb-8">
              不需要準備什麼，直接告訴我你的狀況就好——是初學者？有過學習古箏的經歷？還是幫孩子詢問？都歡迎。
            </p>

            <ul className="space-y-4 mb-10">
              {assurances.map((a, i) => (
                <li key={i} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f5f0e8] shrink-0">
                    <i className={`${a.icon} text-[#7a6248] text-lg`}></i>
                  </div>
                  <p className="text-[1.0625rem] leading-[1.6] text-[#4a3e32]">{a.text}</p>
                </li>
              ))}
            </ul>

            <a
              href="https://line.me"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#06C755] hover:bg-[#05a848] text-white text-[1rem] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-line-fill text-xl"></i>
              加入 LINE@ 諮詢
            </a>
            <p className="mt-4 text-[0.9375rem] text-[#9a8470]">先問問看，再決定也完全可以</p>
          </div>

          {/* Right: Image */}
          <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
            <img
              src="https://readdy.ai/api/search-image?query=person%20holding%20a%20smartphone%20in%20a%20cozy%20warm%20room%2C%20soft%20afternoon%20light%2C%20a%20cup%20of%20tea%20on%20wooden%20table%2C%20peaceful%20relaxed%20atmosphere%2C%20plants%20and%20linen%20texture%2C%20muted%20warm%20tones%2C%20lifestyle%20minimal%20photography&width=700&height=525&seq=contact_line&orientation=landscape"
              alt="聯絡鳴箏"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
